/* Sleek game pop-up: modals, end screen, claim, open/close, triggers */
(function () {
  var G = window.SleekGame;
  if (!G || !G.C) return;
  var T = G.T, M = G.minFor;

  G.modal = function (html) {
    G.ov.innerHTML = '<div class="sg-mod">' + html + '</div>';
    G.ov.hidden = false;
    var b = G.ov.querySelector('button');
    if (b) try { b.focus({ preventScroll: true }); } catch (e) {}
  };
  G.closeModal = function () {
    if (!G.ov) return;
    G.ov.hidden = true;
    G.ov.innerHTML = '';
  };

  G.modalReward = function (t) {
    var nx = G.nextOf(t), d = G.drop(t);
    var txt = 'Cash out now and lock in $' + t + ' off, or keep going ' + (nx.a ? 'for $' + nx.a + ' off (orders $' + M(nx.a) + '+).' : 'to become a Legend.');
    var risk = 'Miss from here and you drop to ' + (d ? '$' + d + ' off' : '$0') + '. ' +
      (G.S.saveUsed ? 'Your save is used, so play carefully.' : 'Your save covers one miss.');
    G.modal('<span class="sg-coin on sg-coinb">$' + t + '</span><p class="sg-eye sg-gold">YOU UNLOCKED</p>' +
      '<h3 class="sg-serif sg-mh">$' + t + ' off orders $' + M(t) + '+</h3><p class="sg-txt">' + txt + '</p>' +
      '<div class="sg-risk">' + risk + '</div>' +
      '<button class="sg-btn sg-dk sg-wide" type="button" data-a="risk">' + (nx.a ? 'Risk it for $' + nx.a + ' off' : 'Go for Legend') + '</button>' +
      '<button class="sg-btn sg-wh sg-wide" type="button" data-a="cash">Cash out $' + t + ' off now</button>');
  };

  G.modalSave = function () {
    var h = G.S.held, d = G.drop(h);
    var risk = h ? '<div class="sg-risk">Walk away now and you drop from $' + h + ' off to ' + (d ? '$' + d + ' off' : '$0') +
      '. Use your save and keep your $' + h + ' off.</div>' : '';
    var no = !h ? "No thanks, I'm done" : d ? 'No thanks, take the $' + d + ' off' : 'No thanks, walk away with $0';
    G.modal('<span class="sg-shield">' + G.svg.shield + '</span><p class="sg-eye sg-gold">USE YOUR SAVE</p>' +
      '<h3 class="sg-serif sg-mh">' + T.lost + '</h3><p class="sg-txt">Share the game and get one more try on this level. One per run.</p>' + risk +
      '<button class="sg-btn sg-dk sg-wide" type="button" data-a="save">Share to save your run</button>' +
      '<button class="sg-btn sg-wh sg-wide" type="button" data-a="nosave">' + no + '</button>');
  };

  G.end = function (result, prev) {
    var S = G.S;
    S.result = result;
    S.prev = prev;
    S.busy = false;
    S.phase = 'end';
    G.closeModal();
    G.track('end', { result: result, level: S.cleared, held: S.held });
    var h, sub = '', pill = '', c = S.cleared;
    if (result === 'legend') h = 'You cleared every level. Legend.';
    else if (result === 'cashed') {
      var nx = G.nextOf(S.held);
      h = 'Smart move.';
      sub = nx.a ? 'Level ' + nx.l + ' would have been $' + nx.a + ' off. Next time.' : 'Level 10 would have made you a Legend. Next time.';
    } else if (result === 'dropped') {
      h = 'You dropped a tier.';
      sub = 'You were holding $' + prev + ' off. That miss cost you. Cash out sooner next time.';
    } else {
      var n = Math.max(1, 3 - c);
      h = T.endNothing;
      sub = "You're " + n + ' level' + (n > 1 ? 's' : '') + ' from your first reward.';
      pill = '<span class="sg-pill">Reach Level 3 to unlock $10 off orders $' + M(10) + '+</span>';
    }
    var rank = c >= 10 ? 'Legend' : c >= 9 ? 'Elite' : c >= 6 ? 'Pro' : c >= 3 ? 'Sharp Eye' : 'Rookie';
    var card = '<div class="sg-share"><div class="sg-shin"><span class="sg-orn">&#9670;</span>' +
      '<p class="sg-eye">' + T.card + '</p><p class="sg-eye sg-lv">LEVEL</p>' +
      (c ? '<p class="sg-serif sg-huge">' + c + '</p>' : '<span class="sg-ring"></span>') +
      '<p class="sg-rank">' + rank + '</p>' +
      (S.held ? '<span class="sg-gpill">$' + S.held + ' off orders $' + M(S.held) + '+ unlocked</span>' : '') +
      '<p class="sg-by">' + T.title + ' by Sleek</p></div></div>';
    G.body.innerHTML = '<div class="sg-end"><h2 id="sg-h" class="sg-serif sg-eh">' + h + '</h2>' + card +
      (sub ? '<p class="sg-txt">' + sub + '</p>' : '') + pill +
      (S.held ? '<button class="sg-btn sg-dk sg-wide" type="button" data-a="claim">Claim my code</button>' : '') +
      '<button class="sg-btn sg-acc sg-wide" type="button" data-a="challenge">Challenge a friend</button>' +
      '<button class="sg-btn sg-wh sg-wide" type="button" data-a="again">Play again</button>' +
      '<p class="sg-eye sg-mut">BEST . LEVEL ' + G.best + '</p><p class="sg-terms">' + T.terms + '</p></div>';
  };

  G.viewClaim = function () {
    var h = G.S.held;
    G.track('claim_open', { held: h });
    G.body.innerHTML = '<form class="sg-claim" novalidate>' +
      '<span class="sg-pill sg-pillc"><span class="sg-coin on">$' + h + '</span>$' + h + ' off orders $' + M(h) + '+</span>' +
      '<h2 id="sg-h" class="sg-serif sg-eh">Where should we send it?</h2><p class="sg-txt">Enter your email to unlock your code.</p>' +
      '<label class="sg-lab">EMAIL <span>(required)</span><input type="email" name="email" required autocomplete="email" placeholder="you@example.com"></label>' +
      '<label class="sg-lab">TEXT ME MY CODE <span>(optional)</span><input type="tel" name="phone" autocomplete="tel" placeholder="(555) 555 5555"></label>' +
      '<label class="sg-chk"><input type="checkbox" name="sms"><span>Yes, text me offers from Sleek. Msg and data rates may apply. Reply STOP to cancel.</span></label>' +
      '<label class="sg-chk"><input type="checkbox" name="age"><span>I\'m 18 or older.</span></label>' +
      '<p class="sg-err" hidden></p>' +
      '<button class="sg-btn sg-dk sg-wide" type="submit">Unlock my code</button>' +
      '<button class="sg-btn sg-wh sg-wide" type="button" data-a="back">Not now</button>' +
      '<p class="sg-terms">' + T.terms + '</p></form>';
    var f = G.body.querySelector('form');
    f.onsubmit = function (e) { e.preventDefault(); G.submit(f); };
    try { f.email.focus({ preventScroll: true }); } catch (e) {}
  };

  G.submit = function (f) {
    var em = f.email.value.trim(), ph = f.phone.value.trim(), err = f.querySelector('.sg-err');
    var bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em) ? 'Please enter a valid email.'
      : !f.age.checked ? 'Please confirm you are 18 or older.'
      : ph && !f.sms.checked ? 'Tick the text box to get offers by text, or clear the phone number.' : '';
    if (bad) { err.textContent = bad; err.hidden = false; return; }
    var btn = f.querySelector('[type=submit]');
    btn.disabled = true;
    btn.textContent = 'Unlocking...';
    G.S.busy = true;
    var h = G.S.held, body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', em);
    if (ph) body.set('contact[phone]', ph);
    body.set('contact[tags]', 'sleek-game,game-' + h + ',game-skin-' + G.C.skin + (ph ? ',sms-optin' : ''));
    var done = false;
    var fin = function () { if (done) return; done = true; G.S.busy = false; G.success(h); };
    try {
      fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin', redirect: 'manual' }).then(fin, fin);
    } catch (e) { fin(); }
    setTimeout(fin, 6000);
  };

  G.success = function (h) {
    var code = G.C.codes[h];
    G.ls.set('sg_claimed', { t: Date.now(), held: h });
    G.track('code_claimed', { held: h });
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
    G.body.innerHTML = '<div class="sg-ok"><p class="sg-eye sg-gold">YOUR CODE</p>' +
      '<h2 id="sg-h" class="sg-serif sg-eh">$' + h + ' off is yours</h2>' +
      '<div class="sg-code"><span>' + code + '</span><button class="sg-btn sg-wh" type="button" data-a="copy">Copy</button></div>' +
      '<p class="sg-txt">We saved it to your cart. Use it at checkout on orders of $' + M(h) + ' or more. One discount per order.</p>' +
      '<button class="sg-btn sg-dk sg-wide" type="button" data-a="shop">Shop now</button>' +
      '<p class="sg-terms">' + T.terms + '</p></div>';
    if (G.launcher) G.launcher.hidden = true;
  };

  /* Open, close, launcher */
  G.open = function (src) {
    G.build();
    if (G.open_) return;
    G.open_ = true;
    G.ss.set('sg_seen', '1');
    G.prevFocus = document.activeElement;
    G.root.hidden = false;
    document.documentElement.classList.add('sg-lock');
    G.S = {};
    G.viewTitle();
    G.track('open', { source: src || 'auto' });
    if (G.launcher) G.launcher.hidden = true;
    setTimeout(function () { var b = G.body.querySelector('[data-a=play]'); if (b) try { b.focus({ preventScroll: true }); } catch (e) {} }, 60);
  };
  G.close = function () {
    if (!G.open_ || (G.S && G.S.busy && G.S.phase === 'end')) return;
    G.open_ = false;
    G.runSeq = (G.runSeq || 0) + 1;
    G.closeModal();
    G.root.hidden = true;
    document.documentElement.classList.remove('sg-lock');
    G.S = {};
    if (!G.claimedRecently()) G.showLauncher();
    try { (G.launcher && !G.launcher.hidden ? G.launcher : G.prevFocus).focus({ preventScroll: true }); } catch (e) {}
  };
  G.showLauncher = function () {
    if (!G.launcher) {
      var b = document.createElement('button');
      b.type = 'button';
      b.id = 'sg-launch';
      b.className = 'sg-' + G.C.skin;
      b.setAttribute('aria-label', 'Play and win a discount');
      b.innerHTML = G.svg.item(true) + '<span>Play and win</span>';
      b.onclick = function () { G.open('launcher'); };
      document.body.appendChild(b);
      G.launcher = b;
    }
    G.launcher.hidden = false;
  };

  /* All buttons */
  function act(a, btn) {
    var S = G.S;
    if (a === 'close') return G.close();
    if (a === 'play' || a === 'again') return G.startRun();
    if (a === 'sound') { G.sound = !G.sound; G.ls.set('sg_sound', G.sound); G.renderHead(); return; }
    if (a === 'next' || a === 'risk') { if (S.busy) return; G.closeModal(); return G.next(); }
    if (a === 'cash') { G.closeModal(); return G.cash(); }
    if (a === 'save') return G.useSave();
    if (a === 'nosave') { G.closeModal(); return G.applyDrop(); }
    if (a === 'claim') return G.viewClaim();
    if (a === 'back') return G.end(S.result, S.prev);
    if (a === 'challenge') return G.share('challenge');
    if (a === 'copy') { G.copy(G.C.codes[S.held] || ''); btn.textContent = 'Copied'; return; }
    if (a === 'shop') return G.close();
  }

  G.init = function () {
    G.build();
    G.root.addEventListener('click', function (e) {
      if (e.target.classList.contains('sg-bd')) { if (!G.S.busy) G.close(); return; }
      var b = e.target.closest('[data-a]');
      if (b && !b.disabled) act(b.getAttribute('data-a'), b);
    });
    document.addEventListener('keydown', function (e) {
      if (!G.open_) return;
      if (e.key === 'Escape') { G.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(G.card.querySelectorAll('button,input,a[href]'), function (x) {
        return !x.disabled && x.offsetParent !== null;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    });

    if (G.claimedRecently()) return;
    var q = location.search;
    if (/[?&]sg=0/.test(q)) return;
    if (/[?&]sg=1/.test(q)) { setTimeout(function () { G.open('friend'); }, 1500); return; }
    if (G.ss.get('sg_seen')) { G.showLauncher(); return; }
    var fired = false;
    var go = function (src) {
      if (fired) return;
      fired = true;
      clearTimeout(timer);
      document.removeEventListener('mouseout', exit);
      G.open(src);
    };
    var timer = setTimeout(function () { go('timer'); }, G.C.delayMs);
    var exit = function (e) { if (e.clientY <= 0 && !e.relatedTarget) go('exit'); };
    document.addEventListener('mouseout', exit);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', G.init);
  else G.init();
})();
